const upcomingSection = $('#upcoming-section');
const upcomingCover = upcomingSection.find('.webinar-cover');
const upcomingCoverBtn = upcomingSection.find('.button-parent');

const upcomingIn = () => {
  const gradientConfig = {
    gradient: 'linear-gradient(127deg, #081B48 0%, #8AD1DA 50%, #081B48 100%);',
    start: 120,
    end: 0,
  };

  const sectionInTL = gsap.timeline({
    paused: true,
  });

  sectionInTL.add(
    animateSectionTopperIn({
      sectionParent: upcomingSection,
      gradientConfig: gradientConfig,
    }).play(),
    0
  );

  sectionInTL.add(elementInAnimationYWOpacity(upcomingCover, '15vw', 0, 1, 1.37).play(), 0);
  addBtnAnimation(upcomingCoverBtn, 50, true);

  return sectionInTL;
};

const initWebinarsUpcoming = () => {
  const upcomingInTL = upcomingIn();
  ScrollTrigger.create({
    trigger: upcomingSection,
    start: 'top top+=120%',
    end: 'top top',
    once: true,
    onUpdate: (self) => {
      upcomingInTL.progress(self.progress);
    },
  });
}

/*
$(window).on('heroReady', () => {
  initWebinarsUpcoming()
});
*/

addSectionObserver(upcomingSection, initWebinarsUpcoming, false);